<template>
    <div id="removeclass">
    <modal
        :modal-id="modalId"
        :title="modalTitle"
        :preloader="preloader"
        @submit="submit"
        @close-modal="closeModal"
    >
      <template slot="body">
        <app-overlay-loader v-if="preloader"/>
        <form
            class="mb-0"
            :class="{ 'loading-opacity': preloader }"
            ref="form"
            :data-url="addUrl"
        >
          <div class="form-group row align-items-center">
            <label class="col-sm-4 mb-0">{{ $t("report_title") }}</label>
            <app-input
                class="col-sm-8"
                type="text"
                :placeholder="$t('report_title')"
                v-model="inputs.title"
                :required=true

            />
          </div>
  
          <div class="form-group row align-items-center">
            <label class="col-sm-4 mb-0">{{ $t("report_description") }}</label>
            <app-input
                class="col-sm-8"
                type="text"
                :placeholder="$t('short_description')"
                v-model="inputs.description"
            />
          </div>
          <div class="form-group row align-items-center">
            <label class="col-sm-4 mb-0">{{ $t("select_user") }}</label>
            <app-input
                class="col-sm-8"
                type="multi-select"
                :placeholder="$t('select_user')"
                :list="users"
                v-model="meta.users"
            />
          </div>
          <div class="form-group row align-items-center">
            <label class="col-sm-4 mb-0">{{ $t("select_form") }}</label>
            <app-input
                class="col-sm-8"
                type="multi-select"
                :placeholder="$t('select_form')"
                :list="forms"
                v-model="meta.form_id"
            />
          </div>
          <div class="form-group row align-items-center">
            <div class="col-12">
              <app-input
                type="single-checkbox"
                :list-value-field="$t('download_full_report')"
                v-model="inputs.full_report"
              />
            </div>
          </div>
        </form>
      </template>
    </modal>
  </div>
  </template>
  
  <script>
  import {FormMixin} from "../../../../../../core/mixins/form/FormMixin.js";
  import {ModalMixin} from "../../../../../Mixins/ModalMixin";
  import * as actions from "../../../../../Config/ApiUrl";
  import {
    axiosPost,
    axiosDelete,
    axiosGet,
  } from "../../../../../Helpers/AxiosHelper";
  import AppLibrary from "../../../../../Helpers/AppLibrary";
  
  export default {
    name: "AddTaskReport",
    extends: AppLibrary,
    mixins: [FormMixin, ModalMixin],
    props: {
      tableId: String,
      task_id: Number,
    },
    data() {
      return {
        hideUserList: true,
        addUrl: actions.TASK_REPORT_STORE,
        preloader: false,
        users: [],
        forms: [],
        inputs: {},
        modalTitle: 'Add Report',
        modalId: "add-task-report-modal",
        meta: {
          users: [],
          form_id: [],
        },
      }
    },
    created() {
      this.getTaskUsers();
      this.getTaskForms();
    },
    watch: {
      company_id() {
        this.getCompanyUsers();
      },
    },
    methods: {
      closeModal() {
        this.$emit('close-modal')
      },
      submit() {
        let companyId = this.$store.state.sharedData.sharedData.companyId;
        this.meta.company_id = companyId ?? this.userRole.company_id;
        this.inputs.meta = this.meta;
        this.inputs.task_id = this.task_id;
        this.save(this.inputs);
      },
      afterSuccess(response) {
        this.$toastr.s(response.data.message);
        this.$hub.$emit("reload-" + this.tableId);
        this.closeModal();
      },
      afterError(response) {
        this.$toastr.e(response.data.message);
      },
      getTaskForms() {
        axiosGet(actions.TASK_FORM_LIST+'/'+this.task_id).then((response) => {
            this.forms = response.data;
        });
      },
      getTaskUsers() {
        axiosGet(actions.TASK_USER_LIST + '/' + this.task_id)
            .then((res) => {
              this.users = res.data;
            })
            .catch((error) => {
              this.$toastr.e(error);
            })
            .finally(() => {
            });
      },
    //   checkIsCompanyAdmin() {
    //     // console.log(this.userRole.company_id);
    //     if (this.userRole.company_id != 1 && this.userRole.is_company_admin == 1) {
    //         this.hideCompanyList = false;
    //         this.company_id = this.userRole.company_id;
    //         this.getCompanyUsers();
    //     }
    //     else if(this.userRole.is_company_admin == 0) {
    //         this.hideCompanyList = false;
    //         this.hideUserList = false;
  
    //         this.company_id = this.userRole.company_id;
    //         this.meta.users = this.userRole.id;
    //     }
    //     else if(this.userRole.company_id == 1 && this.userRole.is_company_admin == 1) {
    //         this.hideCompanyList = true;
    //         this.hideUserList = true;
    //     }
    // }
    },
    mounted() {
    //   this.checkIsCompanyAdmin();
      $(function () {
        $("#removeclass .modal-dialog ").removeClass("modal-dialog-scrollable");
      });
    },
    computed: {
      userRole() {
        return this.$store.state.user.loggedInUser;
      },
    },
  };
  </script>
  